import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { selectReducedText, selectHideDecreasedPriceIcons, availableInText, clearanceText, saleText } from '../store/orderingSlice';

function BulkOrderingAvailableVariantsItem({ variant }) {
	const reduced_text = useSelector(selectReducedText);
	const hide_decreased_price_icons = useSelector(selectHideDecreasedPriceIcons);
	const clearance_text = useSelector(clearanceText);
	const sale_text = useSelector(saleText);

	let price_decreased_text = '';
	if (variant.reduced) {
		price_decreased_text = reduced_text;
	} else if (variant.closeout) {
		price_decreased_text = clearance_text
	} else if (variant.sale) {
		price_decreased_text = sale_text
	}
	const price_decreased_class_name = classNames({
		'color-browser-card__size-icon--is-reduced': !hide_decreased_price_icons && variant.reduced,
		'color-browser-card__size-icon--is-closeout':
			!hide_decreased_price_icons && !variant.reduced && variant.closeout,
		'color-browser-card__size-icon--is-sale':
			!hide_decreased_price_icons && !variant.reduced && !variant.closeout && variant.sale,
	});

	const li_class_name = classNames({
		'color-browser-card__size': true,
		'color-browser-card__size--is-backordered': variant.backordered,
		'color-browser-card__size--is-low-stock': variant.low_stock,
		'color-browser-card__size--is-reduced': variant.reduced,
		'color-browser__size--is-closeout': !variant.reduced && variant.closeout,
		'color-browser__size--is-sale': !variant.reduced && !variant.closeout && variant.sale,
	});

	return (
		<li className={li_class_name}>
			{variant.label}
			{(variant.low_stock || price_decreased_text) && (
				<div className='color-browser-card__size-icons'>
					{variant.low_stock && (
						<span
							className='color-browser-card__size-icon color-browser-card__size-icon--is-low-stock'
							title='Low Stock'
						></span>
					)}
					{price_decreased_text && (
						<span
							className={`color-browser-card__size-icon ${price_decreased_class_name}`}
							title={price_decreased_text}
						></span>
					)}
				</div>
			)}
		</li>
	);
}

export function BulkOrderingAvailableVariants({ variants }) {
	const available_text = useSelector(availableInText);

	return (
		<>
			<div className='color-browser-card__sizes-label'>{available_text}:</div>
			<ul className='color-browser-card__sizes-list'>
				{variants.map((variant, index) => (
					<BulkOrderingAvailableVariantsItem key={index} variant={variant} />
				))}
			</ul>
		</>
	);
}
